import React, { forwardRef, ReactElement, useEffect, useState } from 'react';
import { InputBase } from 'component-library/index';

export interface IAptProps {
    addressType?: string;
    className?: string;
    inputClass?: string;
    id?: string;
    errorText?: string;
    label?:  string | ReactElement | ReactElement[];
    error?: boolean;
    required?: boolean;
    requiredMessage?: string;
    alternate?: boolean;
    maxLength?: number;
    invalidErrorMessage?: string;
    valid?: [boolean, (arg?: any) => void];
    value?: string;
    useSuccessIcon?: boolean;
    showSuccessIcon?: boolean;
    useOutsideValidation?: boolean;
    setValueCallback: THandlerFunction;
    onBlurCallback?: (((value: React.FocusEvent<HTMLInputElement>) => void) & React.FocusEventHandler<any>);
    onFocusCallback?: (((value: React.FocusEvent<HTMLInputElement>) => void) & React.FocusEventHandler<any>);
    onKeyDownCallback?: (((value: React.FocusEvent<HTMLInputElement>) => void) & React.KeyboardEventHandler<any>);
    disabled?: boolean;
    isPrefill?: boolean;
}

const ApartmentField = (({    
    value = '',
    className,
    setValueCallback,
    onBlurCallback,
    onFocusCallback,
    onKeyDownCallback,
    useSuccessIcon,
    showSuccessIcon,
    useOutsideValidation,
    valid,
    isPrefill,
    addressType,
    ...rest 
}: IAptProps, ref: React.Ref<any>) => {
    const [showIcon, setShowIcon] = useState(false);
    const [isFieldValid, setIsFieldValid] = useState(false);
    const [isBlurred, setIsBlurred] = useState(false);
    const validity = valid ?? [isFieldValid, setIsFieldValid];
 
    const validateField = () => {
        value = value ? value.trim(): '';
        return value && value.length <= 100;
    };

    const focusHandler = (e: React.FocusEvent<HTMLInputElement>) => {
        if (e.type === 'blur') {
            onBlurCallback && onBlurCallback(e);
        } else if (e.type === 'focus') {
            onFocusCallback && onFocusCallback(e);
        }
        setIsBlurred(e.type !== 'focus');
        handleSuccessIcon(e.type === 'focus');
    };

    const handleSetValue = (e) => {
        if (!validity[0]) {
            validity[1](true);
        }
        setValueCallback && setValueCallback(e);
    };

    const handleSuccessIcon = (isActive: boolean = false) => {
        const isShowIcon = (value !== '' ? (useOutsideValidation ?? true): true) && validateField() && !isActive;
        setShowIcon(isShowIcon);
    };

    useEffect(() => {
        setIsBlurred(true);
    }, []);

    useEffect(() => {
        if (useOutsideValidation === undefined || !isBlurred)
            return;

        handleSuccessIcon(!useOutsideValidation);
    }, [value, useOutsideValidation]);

    useEffect(() => {
        if (isPrefill) {
            setShowIcon(false);
        }
    }, [isPrefill]);

    return (
        <div className={`ApartmentField ${className ?? ''}`}>
            <InputBase
                {...rest}
                ref={ref}
                value={value}
                setValue={handleSetValue}
                onBlur={focusHandler}
                onFocus={focusHandler}
                onKeyDown={onKeyDownCallback}
                isValid={validateField}
                valid={validity}
                useSuccessIcon={useSuccessIcon}
                showSuccessIcon={showSuccessIcon !== undefined ? showSuccessIcon : showIcon}
                showExclamationError
                containerId={`${addressType}AptUnit-field-container`}
            />
        </div>
    );
});

export default forwardRef(ApartmentField);